<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
        <div class="col-lg-12">
            <div class="card card-danger card-outline">
                <div class="card-header">
                    <div class="card-title">Data Filters</div>
                    <div class="card-tools">
                        <!-- Collapse Button -->
                        <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="col-lg-12 float-left">
                        <div class="row">
                            <div class="col-sm-3" v-if="$gate.isMISAdmin()">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">Company:</span>
                                    <v-select v-model="company" class="form-control" type="text" label="name" :options="companies" :reduce="companies => companies.code" name="company" placeholder="Select Company" :value="companies => companies.code"></v-select>
                                </div>
                            </div>
                            <div class="col-sm-3" v-if="$gate.isMISAdmin()">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">Search by Branch:</span>
                                    <v-select v-model="branch" type="text" label="fullname" :options="branches" :reduce="branches => branches.branch_code" placeholder="Select Branch" :value="branches => branches.branch_code"></v-select>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">From Date:</span>
                                    <input type="date" class="form-control" placeholder="From Date" v-model="fromdate">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <span class="right badge badge-secondary">To Date:</span>
                                    <input type="date" class="form-control" placeholder="To Date" v-model="todate">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <button class="btn btn-primary" style="width:100% !important;" @click="getStats">Generate</button>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <button class="btn btn-danger" style="width:100% !important;" @click="reset">Reset</button>
                                </div>
                            </div>
                        </div>
                        <!--                        <div class="row">-->
                        <!--                            -->
                        <!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
<!--					<div class="card-header">-->
<!--						-->
<!--					</div>-->
					<div class="card-body overflow-auto">

					</div>
					<div class="card-footer">

					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){

        },

        data(){
        	return {}
        },

        methods: {

        }
    }
</script>
